import httpService from '@Utils/httpService';

//const dataApi = 'api/data';
const baseUrl = 'api/Document-Types';

export default {
  get(params) {
    return httpService.get({
      url: baseUrl,
      params,
    });
  },
  getById(id) {
    return httpService.get({
      url: `${baseUrl}/${id}`,
    });
  } 


};
